import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BASE_URL, BaseApi, DateHelpers } from "@edl-development/edl-common";
import { CplTimeTrackingReportRequest } from "src/app/model/cpl-time-tracking-report-reqest.model";
import { TimeTrackingTypes } from "src/app/model/enum/cpl-time-tracking-type.enum";
import { TimeTrackingExportResult } from "src/app/model/time-tracking/report-export/time-tracking-export-result.model";


@Injectable()
export class ReportsApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getTimeReport(details: CplTimeTrackingReportRequest){
        let params = new HttpParams()
            .append('offset', String(details.Offset))
            .append('limit', String(details.Limit))
            .append('type', <number>details.Type)
            .append('Perms', <number>details.Perms)
            .append('TimeTrackingType', details.TimeTrackingType ?? TimeTrackingTypes.ACT48)
            .append('UserID', this.convertParam(details.UserID))
            .append('StartDate', DateHelpers.DateToShortDate(details.StartDate))
            .append('EndDate', DateHelpers.DateToShortDate(details.EndDate))
            .append('ShouldGetAll', details.ShouldGetAll);

        return this.http.get(this.baseUri + '/report/time', { params });
    }

    getTimeReportExport({userId, startDate, endDate}){
        const shortStartDate = DateHelpers.DateToShortDate(startDate);
        const shortEndDate = DateHelpers.DateToShortDate(endDate);
        const params = new HttpParams()
            .set('UserID', userId)
            .set('StartDate', shortStartDate)
            .set('EndDate', shortEndDate)
            .set('ShouldGetAll', true);
        return this.http.get<TimeTrackingExportResult[]>(this.baseUri + '/report/time/export', { params });
    }
}